import { statisticsInstances } from '@yuanfudao/metis-web-component/dist/utils'
import { statisticsInstances as loginStatisticsInstances } from '@yuanfudao/metis-unified-login/es/utils/statistics'
import pkgJson from '../../package.json'

statisticsInstances.setSdkUserInfo({
  sdkUserName: pkgJson.name,
  sdkUserVersion: pkgJson.version,
})
loginStatisticsInstances.setSdkUserInfo({
  sdkUserName: pkgJson.name,
  sdkUserVersion: pkgJson.version,
})
